'use strict';

var buildFromIndexMethods = require('../internal/buildFromIndexMethods');

buildFromIndexMethods();


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/enumerable/build/buildFromIndexMethodsCall.js
// module id = 49
// module chunks = 0